<template>
    <el-dialog
        title="你已提交报名信息"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="460px"
        :destroy-on-close="true"
        >

        <div class="success-view">

            <div class="wrapper"></div>
            <div class="header"></div>

            <div class="content">
              <div class="title"></div>
                <div>请将战队码：<em class="code">{{ code }} </em>告知给你的队员，待所有队员确认加入战队后才算有效报名。<p>队长请加官方QQ群：<a v-bind:href="quick_link" target="_blank">{{ qq_group }}</a>，及时接受赛程安排通知。</p></div>
            </div>
        </div>
    </el-dialog>    
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        code : '2887',
        qq_group : '1033737653',
        quick_link : 'https://jq.qq.com/?_wv=1027&k=2kkgrRF4',
      };
    },
    methods: {
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      call_code_view() {
          this.$refs.inner_code_modal.dialogVisible = true;
          //this.$refs.inner_code_modal.$refs.code_input.focus();
      },
    }
  };
</script>

<style scoped>

    .success-view{
        position: relative;
        width: 450px;
        height: 298px;
        margin: 5px auto;
        z-index: 2;       
    }

    .wrapper{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/images/wrapper-hint.png);
        z-index: 2;
        pointer-events: none;       
    }

    .header{
        width: 447px;
        height: 45px;
        margin: 0 auto;
        background-image: url(~@/assets/images/header-hint.png);
    }

    .success-view .content{
      padding: 60px 50px 0;
      margin-bottom: 105px;
      font-size: 16px;
      color: #8c6f48;
      font-family: "pageFont_SYH";
    }
  
    .success-view .code,
    .success-view .content a{
      color: #cfae82;
      text-decoration: none;
    }

    .success-view .content p{
      margin-top: 20px;
    }

    .u-btn{
        display: block;
        width: 295px;
        height: 65px;
        line-height: 65px;
        margin: 0 auto;
        background-color: #820000;
        color: #fff;
        font-size: 24px;
        text-align: center;
    }
    
    .u-btn a{
      display: block;
      width: 100%;
      height: 100%;
      color: #fff;
    }

    .title{
      width: 200px;
      height: 24px;
      margin: 0 auto 22px;
      background-image: url(~@/assets/images/title-success.png);
    }
</style>


// WEBPACK FOOTER //
// src/components/successModal/successModal.vue